// alternative-dashboard\alternative-components\TotalAssetsWidget.tsx
import { ICON_BASE_PATH } from "@/app/utils/config";
import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";
import { Loader } from "@progress/kendo-react-indicators";
import { useT } from "@/app/hooks/useT";
import { useNavigate } from "react-router-dom";

interface TotalAssetsWidgetProps {
  amount: number;
  currencyLabel: string;
  details: string;
  isLoading?: boolean;
  showDash?: boolean;
}

const ASSETS_DECIMAL_COLOR = "#848484";

function TotalAssetsWidget({
  amount,
  currencyLabel,
  details,
  isLoading = false,
  showDash = false,
}: TotalAssetsWidgetProps) {
  const t = useT();
  const router = useNavigate();

  const renderFormattedAmount = (
    value: number,
    currency: string,
    decimalColor: string = ASSETS_DECIMAL_COLOR,
  ) => {
    const formatResult = gxCurrencyFormat(value, currency);

    return (
      <>
        <span className="gx-span-currencycode">{formatResult.symbol}</span>{" "}
        {formatResult.integer}
        {formatResult.decimal && (
          <span style={{ color: decimalColor }}>{formatResult.decimal}</span>
        )}
      </>
    );
  };

  const renderAmount = () => {
    if (isLoading) {
      return (
        <div className="gx-pulse">
          <Loader size="small" />
        </div>
      );
    }

    if (showDash) {
      return "-";
    }

    return (
      <span className="gx-h3-sb">
        {renderFormattedAmount(amount, currencyLabel)}
      </span>
    );
  };

  return (
    <button
      type="button"
      className="gx-bal-assets-card"
      onClick={() => router("/dashboard/assets/")}
    >
      <div className="gx-bal-card-content">
        <div className="gx-bal-card-acc-info">
          <h4 className="gx-h4-sb">{t("total_assets")}</h4>
          <div className="gx-bal-amount gx-font-semibold">{renderAmount()}</div>
          <p className="gx-p10-sb">{details}</p>
        </div>
        <div className="gx-bal-card-icon-wrapper">
          <div className="gx-bal-card-icon-container">
            <img
              className="gx-bal-card-icon"
              src={`${ICON_BASE_PATH}assetsarrow.svg`}
              alt="Assets Icon"
            />
          </div>
        </div>
      </div>
    </button>
  );
}

export default TotalAssetsWidget;

// // alternative-dashboard\alternative-components\TotalAssetsWidget.tsx
// import { ICON_BASE_PATH } from "@/app/utils/config";
// import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";
// import { Loader } from "@progress/kendo-react-indicators";
// import { useT } from "@/app/hooks/useT";
// import { useNavigate } from "react-router-dom";

// interface TotalAssetsWidgetProps {
//   amount: number;
//   currencyLabel: string;
//   details: string;
//   isLoading?: boolean;
//   showDash?: boolean;
// }

// function TotalAssetsWidget({
//   amount,
//   currencyLabel,
//   details,
//   isLoading = false,
//   showDash = false,
// }: TotalAssetsWidgetProps) {
//   const t = useT();
//   const router = useNavigate();

//   const renderFormattedAmount = (
//     value: number,
//     currency: string,
//     decimalColor: string = "#67AD5A",
//   ) => {
//     const formatResult = gxCurrencyFormat(value, currency);
//     return (
//       <>
//         {formatResult.integer}
//         {formatResult.decimal && (
//           <span style={{ color: decimalColor }}>{formatResult.decimal}</span>
//         )}
//       </>
//     );
//   };

//   return (
//     <button
//       type="button"
//       className="gx-bal-assets-card"
//       onClick={() => router("/dashboard/assets/")}
//     >
//       <div className="gx-bal-card-content">
//         <div className="gx-bal-card-acc-info">
//           <h4 className="gx-h4-sb">{t("total_assets")}</h4>
//           <div className="gx-bal-amount gx-font-semibold">
//             {isLoading ? (
//               <div className="gx-pulse">
//                 <Loader size="small" />
//               </div>
//             ) : showDash ? (
//               "-"
//             ) : (
//               <>
//                 <small className="gx-p16-b">{currencyLabel}</small>{" "}
//                 <span className="gx-h3-sb">
//                   {renderFormattedAmount(amount, currencyLabel)}
//                 </span>
//               </>
//             )}
//           </div>
//           <p className="gx-p10-sb">{details}</p>
//         </div>
//         <div className="gx-bal-card-icon-wrapper">
//           <div className="gx-bal-card-icon-container">
//             <img
//               className="gx-bal-card-icon"
//               src={`${ICON_BASE_PATH}assetsarrow.svg`}
//               alt="Assets Icon"
//             />
//           </div>
//         </div>
//       </div>
//     </button>
//   );
// }

// export default TotalAssetsWidget;
